export const errorMessages: Record<string, string> = {
  PORTFOLIO_WEIGHT_SUM_MISMATCH: "Portfolio fund weights don't add up to 100%.",

  INVALID_FUND_IN_PORTFOLIO: 'Fund in the order does not belong to the portfolio.',

  ALLOCATION_SUM_MISMATCH: 'Fund allocation sum does not match subscription amount.',

  AGGREGATE_FUND_AMOUNT_MISMATCH: 'User allocations sum does not match fund order total.',

  REDEEM_EXCEEDS_PORTFOLIO_VALUE: 'Redemption amount exceeds portfolio value.',

  ESTIMATED_UNITS_EXCEED_BANK: 'Not enough units to cover the redemption.',

  STALE_OR_INVALID_NAV: 'Fund NAV is invalid or unavailable.',

  ESTIMATED_UNITS_NOT_FULL_BANK: "Sell order doesn't cover all user units — expected full exit.",
};

// Helper function to extract error message
export function getErrorMessage(reasonCode?: string, fallback?: string) {
  if (!reasonCode) return fallback || 'An unexpected error occurred';

  return errorMessages[reasonCode] || fallback || 'An unexpected error occurred';
}
